// IMPORTANT NOTE: Please don't import other selectors from this file.
// Use secondOrder and *ThirdOrder for your selector if it has other
// dependencies.
import { identity } from 'lodash'
import { createSelector } from 'reselect'
import { initialSystemState } from '../store/initialSystemState'

/**
 * @typedef {import('../index').PlottrState} PlottrState
 * @typedef {import('../index').PlottrFile} PlottrFile
 * @typedef {import('../index').SystemState} SystemState
 */

/**
 * @type{function(PlottrState): PlottrState}
 */
export const rawFileStateSelector = identity
/**
 * @type {function(PlottrState): PlottrFile}
 */
export const fullFileStateSelector = createSelector(rawFileStateSelector, ({ user }) => user)
/**
 * @type {function(PlottrState): SystemState}
 */
export const fullSystemStateSelector = createSelector(
  rawFileStateSelector,
  ({ system }) => system ?? initialSystemState
)
